export const routes = {
  fights: {
    root: '/',
    home: '/',
    saved: '/saved',
    deals: '/deals',
    account: '/account',
    guides: {
      root: '/guides',
      athens: '/guides/athens',
    },
  },
};
